export const fetchGenericEmailTypes = (payload) => {
    return {
        type: "FETCH_GENERIC_EMAIL_TYPES",
        payload
    }
};

export const createGenericEmailType = (payload) => {
    return {
        type: "CREATE_GENERIC_EMAIL_TYPE",
        payload
    }
};

export const deleteGenericEmailType = (payload) => {
    return {
        type: "DELETE_GENERIC_EMAIL_TYPE",
        payload
    }
};
